import {
  ClearOutlined,
  CloudDownloadOutlined,
  LoadingOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Col as ACol,
  DatePicker as ADatePicker,
  Drawer as ADrawer,
  Input as AInput,
  Row as ARow,
  Select as ASelect,
  Table as ATable,
  App,
  Button,
  Card,
  Form,
  Popconfirm,
  Skeleton,
  Space,
  Spin,
  Statistic as AStatistic,
  Switch,
} from "antd";
import { Curl, FloatMul } from "components/Jarvis";
import ExportButton from "components/ExportButton";
import dayjs from "dayjs";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Pie as APie } from "@ant-design/plots";

const EndeavourContext = createContext();

const EndeavourProvider = ({ children }) => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerData, setDrawerData] = useState(null);
  const [pageTitle, setPageTitle] = useState("");

  const openDrawer = (data) => {
    setDrawerData(data);
    setDrawerVisible(true);
  };
  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  return (
    <EndeavourContext.Provider
      value={{ openDrawer, closeDrawer, pageTitle, setPageTitle }}
    >
      <Drawer open={drawerVisible} onClose={closeDrawer} {...drawerData} />
      {children}
    </EndeavourContext.Provider>
  );
};

const useEndeavour = () => {
  const endeavour = useContext(EndeavourContext);
  return {
    openDrawer: endeavour.openDrawer,
    closeDrawer: endeavour.closeDrawer,
    pageTitle: endeavour.pageTitle,
    setPageTitle: endeavour.setPageTitle,
  };
};

const round = (amount, currency) => {
  amount = amount === null ? 0 : amount;

  switch (currency) {
    default:
      return FloatMul(amount, 1, 2);
  }
};

Spin.setDefaultIndicator(
  <LoadingOutlined
    style={{
      fontSize: 28,
    }}
  />
);

const Drawer = ({ ...props }) => {
  return <ADrawer {...props} />;
};

const fontSize = 12;
const Theme = {
  token: {
    fontSize: fontSize,
    fontFamily: "'Goldman Sans','Noto Sans SC',sans-serif,-apple-system",
    // fontFamily: "'Goldman Sans', Kanit, -apple-system,'Noto Sans SC'",
    // fontFamily: "Kanit, -apple-system,'Noto Sans SC'",
    // borderRadius: 0,
    colorPrimary: "#386c9a",
    // colorInfo: "#386c9a",
  },
  // components: {
  //   Button: {
  //     contentFontSize: fontSize,
  //     paddingInline: 16,
  //     onlyIconSize: fontSize,
  //     onlyIconSizeLG: fontSize,
  //     onlyIconSizeSM: fontSize,
  //   },
  //   Form: {
  //     itemMarginBottom: 16,
  //     verticalLabelPadding: "0",
  //   },
  //   Statistic: {
  //     contentFontSize: fontSize,
  //   },
  //   Divider: {
  //     fontSizeLG: fontSize,
  //   },
  //   Card: {
  //     paddingLG: 16,
  //     headerFontSize: fontSize,
  //     headerFontSizeSM: fontSize,
  //     fontSizeLG: fontSize,
  //   },
  //   Table: {
  //     cellFontSize: fontSize,
  //     cellFontSizeMD: fontSize,
  //     cellFontSizeSM: fontSize,
  //     // fontFamily: "'Goldman Sans', Kanit, -apple-system,'Noto Sans SC'",
  //     cellPaddingInline: 8,
  //     margin: 4,
  //     padding: 4,
  //     // cellPaddingInline: 4,
  //     borderRadius: 0,
  //     headerBorderRadius: 0,
  //   },
  //   Menu: {
  //     borderRadius: 0,
  //     borderRadiusLG: 0,
  //     itemMarginInline: 0,
  //   },
  //   Input: {
  //     borderRadius: 0,
  //     borderRadiusSM: 0,
  //     borderRadiusLG: 0,
  //   },
  //   Select: {
  //     borderRadius: 0,
  //     borderRadiusSM: 0,
  //     borderRadiusLG: 0,
  //     optionFontSize: fontSize,
  //     fontSizeLG: fontSize,
  //     fontSizeSM: fontSize,
  //     borderRadiusXS: 0,
  //   },
  //   Layout: {
  //     // siderBg: "#ffffff", // TODO waiting antd to fix it https://github.com/ant-design/ant-design/issues/40531
  //     headerBg: "transparent",
  //     headerPadding: "8px 16px",
  //     headerHeight: "auto",
  //     footerPadding: "0 16px 16px",
  //   },
  //   Typography: {
  //     fontFamilyCode: "'PT Mono', 'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  //   },
  //   Statistic: {
  //     // fontFamily: "'Goldman Sans', Kanit, -apple-system,'Noto Sans SC'",
  //     contentFontSize: fontSize,
  //   },
  // },
  components: {
    Statistic: {
      // fontFamily: "'Goldman Sans', Kanit, -apple-system,'Noto Sans SC'",
      contentFontSize: fontSize,
    },
  },
};
const ChartTheme = {
  styleSheet: {
    fontFamily: Theme.token.fontFamily,
  },
};

const Row = ({ gutter = [16, 16], children }) => {
  return <ARow gutter={gutter}>{children}</ARow>;
};

const Col = ({ span = 24, children, ...props }) => {
  return (
    <ACol span={span} {...props}>
      {children}
    </ACol>
  );
};

const ISO8601 = (time) => {
  if (/\d{10}/.test(time)) {
    time = time * 1000;
  }

  const date = new Date(time);
  const formatted = date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const [datePart, timePart] = formatted.split(", ");
  const [month, day, year] = datePart.split("/");

  return `${year}-${month}-${day} ${timePart}`;
};

const is_empty = (value) => {
  if (typeof value === "string" && value.length > 0) {
    return false;
  }
  return true;
};

class RangePicker extends React.Component {
  render() {
    const {
      presets = [
        { label: "TODAY", value: [dayjs(), dayjs()] },
        {
          label: "YESTERDAY",
          value: [dayjs().add(-1, "d"), dayjs().add(-1, "d")],
        },
        { label: "LAST 7 DAYS", value: [dayjs().add(-7, "d"), dayjs()] },
        { label: "LAST 14 DAYS", value: [dayjs().add(-14, "d"), dayjs()] },
        { label: "LAST 30 DAYS", value: [dayjs().add(-30, "d"), dayjs()] },
      ],
      ...props
    } = this.props;
    return <ADatePicker.RangePicker {...props} presets={presets} allowClear />;
  }
}

class Select extends React.Component {
  render() {
    const { options = [], ...props } = this.props;
    return <ASelect {...props} options={options} allowClear showSearch />;
  }
}

class Input extends React.Component {
  render() {
    const { autoComplete = "off", allowClear = true, ...props } = this.props;
    return (
      <AInput {...props} allowClear={allowClear} autoComplete={autoComplete} />
    );
  }
}

const InlineVerticalSpace = ({ children }) => {
  return (
    <Space
      direction="vertical"
      style={{
        rowGap: 0,
      }}
    >
      {children}
    </Space>
  );
};

// const Table = ({ rowKey = "id", size = "small", columns = [], ...props }) => {
//   return <ATable rowKey={rowKey} size={size} columns={columns} {...props} />;
// };

const Table = ({
  rowKey = "id",
  size = "small",
  columns = [],
  dataSource = [],
  ...props
}) => {
  const dataWithKeys = dataSource.map((item, index) => ({
    ...item,
    key: item[rowKey] || index,
  }));

  return (
    <ATable
      rowKey="key"
      size={size}
      columns={columns}
      dataSource={dataWithKeys}
      {...props}
    />
  );
};

let runningExport = false;
const SearchTable = ({
  name,
  uri,
  title = "Filters",
  allowExport,
  allowNumberOfPage = 30,
  exportColumns,
  exportButtonSetting = {},
  filename,
  tableExpendable,
  searchFields = [],
  tableColumns = [],
  tableScroll = {
    x: true,
    // y: 512,
  },
  tableRowSelection,
  autoRefetech,
  tableRowKey = "id",
  cardSize = "small",
  formSize = "middle",
  tableSize = "small",
  span = 24,
  forceupdate,
}) => {
  const { notification } = App.useApp();
  const [form] = Form.useForm();
  const [formData, setFormData] = useState({ page: 1 });
  const [pagination, setPagination] = useState({ current: 1 });
  const [elapsed, setElapsed] = useState(0);
  const [refetechInternal, setRefetchInternal] = useState(false);

  const query = useQuery({
    queryKey: ["search-table", name],
    queryFn: () => {
      let _start = performance.now();
      let params = new URLSearchParams();
      for (const k in formData) {
        if (formData.hasOwnProperty(k) && formData[k] !== undefined) {
          switch (typeof formData[k]) {
            case "object":
              params.append(
                "from",
                Math.floor(
                  dayjs(
                    `${formData[k][0].format("YYYY-MM-DD 00:00:00")}`
                  ).valueOf() / 1000
                )
              );
              params.append(
                "to",
                Math.floor(
                  dayjs(
                    `${formData[k][1].format("YYYY-MM-DD 23:59:59")}`
                  ).valueOf() / 1000
                )
              );
              continue;
            default:
              params.append(k, formData[k]);
          }
        }
      }
      const query = params.toString();
      return Curl.get(`${uri}?${query}`).then((data) => {
        setElapsed(((performance.now() - _start) / 1000).toFixed(4));
        setPagination(data.payload.pagination);
        return data.payload.data;
      });
    },
    refetchInterval: refetechInternal ? refetechInternal * 1000 : false,
  });

  const onFormFinish = (data) => {
    setFormData({
      page: 1,
      ...data,
    });
  };

  const onTableChange = (data) => {
    setFormData((prev) => ({
      ...prev,
      page: data.current,
    }));
  };

  useEffect(() => {
    query.refetch();
  }, [forceupdate]);

  useEffect(() => {
    query.refetch();
  }, [formData]);

  return (
    <Row>
      {searchFields.length > 0 && (
        <Col span={span}>
          <Card
            title={title}
            size={cardSize}
            extra={
              <Space>
                {autoRefetech && (
                  <Switch
                    onChange={(value) => {
                      value
                        ? setRefetchInternal(autoRefetech)
                        : setRefetchInternal(false);
                    }}
                    unCheckedChildren="Auto Refresh"
                    checkedChildren="Auto Refresh"
                    loading={query.isFetching}
                  />
                )}
              </Space>
            }
          >
            <Form
              autoComplete="off"
              size={formSize}
              form={form}
              layout="vertical"
              onFinish={onFormFinish}
              labelAlign="right"
              // labelCol={{ span: 8 }}
            >
              <Row gutter={[8, 8]}>
                {searchFields.map((field, i) => {
                  return (
                    <Col key={i} span={6}>
                      {field}
                    </Col>
                  );
                })}
              </Row>
              <Row>
                <Col
                  style={{
                    textAlign: "right",
                  }}
                >
                  <Space>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={query.isFetching}
                      icon={<SearchOutlined />}
                    >
                      Search
                    </Button>
                    {allowExport && (
                      <ExportButton
                        allowNumberOfPage={allowNumberOfPage}
                        searchTableFormData={formData}
                        setSearchTableFormData={setFormData}
                        settings={exportButtonSetting}
                        columns={exportColumns ? exportColumns : tableColumns}
                        searchTableTotalPage={Math.ceil(
                          pagination.total / pagination.pageSize
                        )}
                        name="CSVExport"
                        searchTableQuery={query}
                        filename={filename}
                      />
                    )}
                    <Button
                      icon={<ClearOutlined />}
                      onClick={() => {
                        form.resetFields();
                      }}
                    >
                      Reset
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form>
          </Card>
        </Col>
      )}
      <Col>
        <Table
          // bordered
          rowKey={tableRowKey}
          rowSelection={tableRowSelection}
          size={tableSize}
          expandable={tableExpendable}
          columns={tableColumns}
          loading={query.isFetching}
          dataSource={query.data}
          scroll={tableScroll}
          pagination={{
            ...pagination,
            locale: {
              page: "",
            },
            showTotal: (total, range) => {
              if (total <= 1) {
                return `${total} Record in ${elapsed} seconds`;
              }
              // total = total.toFixed(0);
              return `${total.toLocaleString()} Records in ${elapsed} seconds`;
            },
            position: ["topRight", "bottomRight"],
            showSizeChanger: false,
            showQuickJumper: true,
          }}
          onChange={onTableChange}
          sticky={{
            offsetHeader: 0,
          }}
        />
      </Col>
    </Row>
  );
};

const ASyncButton = ({
  children,
  icon,
  onClick,
  type,
  popConfirm,
  popConfirmTitle,
  popConfirmDescription,
}) => {
  const [loading, setLoading] = useState(false);

  if (popConfirm) {
    return (
      <Popconfirm
        onConfirm={onClick}
        title={popConfirmTitle}
        description={popConfirmDescription}
      >
        <Button icon={icon} type={type}>
          {children}
        </Button>
      </Popconfirm>
    );
  }

  return (
    <Button loading={loading} icon={icon} type={type} onClick={onClick}>
      {children}
    </Button>
  );
};

const Pie = ({ name, title, uri, ...props }) => {
  const query = useQuery({
    queryKey: ["pie", name],
    queryFn: () => {
      return Curl.get(uri).then((res) => {
        return res.payload;
      });
    },
    initialData: [],
  });

  return (
    <Card title={title} size="small">
      <Skeleton loading={query.isFetching} paragraph={{ rows: 1 }}>
        <APie
          data={query.data}
          // radius={0.8}
          padding={16}
          autoFit
          label={{
            labelHeight: 28,
            content: "{name}\n{value}",
          }}
          interactions={[
            {
              type: "element-active",
            },
          ]}
          angleField="subtotal"
          colorField="category_code"
          // meta={{
          //   formatter: (data) => {
          //     console.log(data);
          //   },
          // }}
          {...props}
          tooltip={
            {
              // formatter: (data) => {
              //   return { name: data.x, value: data.y };
              // },
              // customContent: (title, data) => {
              //   return (
              //     <div
              //       style={{
              //         padding: 16,
              //       }}
              //     >
              //       <InlineVerticalSpace>
              //         {title}
              //         <Statistic
              //           value={data[0]?.value}
              //           suffix="USD"
              //           valueStyle={{
              //             fontFamily: Theme.token.fontFamily,
              //             fontSize: Theme.token.fontSize,
              //           }}
              //         />
              //       </InlineVerticalSpace>
              //     </div>
              //   );
              // },
            }
          }
          theme={ChartTheme}
        />
      </Skeleton>
    </Card>
  );
};

const Statistic = ({
  value,
  prefix,
  suffix,
  precision = 2,
  valueStyle,
  ...props
}) => {
  if (value === null || value === undefined) {
    return;
  }
  return (
    <AStatistic
      prefix={prefix}
      value={value}
      suffix={suffix}
      precision={precision}
      valueStyle={{
        fontFamily: "Goldman Sans",
        ...valueStyle,
      }}
      {...props}
    />
  );
};

export {
  ASyncButton,
  Statistic,
  Col,
  Pie,
  EndeavourContext,
  EndeavourProvider,
  ISO8601,
  InlineVerticalSpace,
  Input,
  RangePicker,
  Row,
  SearchTable,
  Select,
  Theme,
  is_empty,
  round,
  useEndeavour,
};
